var firestore = firebase.firestore();

var page = "Lean Canvas";
var feature = {};
var benefits = [];

function cleanData(snapshots) {
    let data = [];
    snapshots.forEach(function(doc) {
        data.push({
            id: doc.id,
            ...doc.data()
        });
    });
    return data;
};

function fetchFeature(page) {

  var docRef = firestore.collection("features").doc("NFu1U3p183v7HduY8IYl");

  docRef.get().then((doc) => {
      if (doc.exists) {
          feature = doc.data();
          fetchBenefits(page);
          console.log("Document data:", doc.data());
      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
  }).catch((error) => {
      console.log("Error getting document:", error);
  });
};

function fetchBenefits(page) {
  return firestore
      .collection("benefits").orderBy("created") //.where('feature', '==', page).
      .get()
      .then((snapshots) => cleanData(snapshots))
      .then((items) => items.map((item) => benefits.push(item)));
};

console.log(benefits);
